import * as React from "react";
const SvgX = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 2L2 14M2 2L14 14", stroke: "#EC221F", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgX;
